import {Injectable} from '@angular/core';
import {ReportType} from '../models/report-type.model';
import {ReportDatepickerShiftCoordinator} from './report-datepicker-shift.coordinator';
import {
  ReportDatepickerWorkflowView,
  ReportRequestContext
} from './report-datepicker.types';
import {ReportDatepickerVacationCoordinator} from './report-datepicker-vacation.coordinator';

@Injectable()
export class ReportDatepickerSpecialRequestCoordinator {
  constructor(
    private vacations: ReportDatepickerVacationCoordinator,
    private shifts: ReportDatepickerShiftCoordinator
  ) {
  }

  dispatch(view: ReportDatepickerWorkflowView, context: ReportRequestContext): boolean {
    if (view.reportType === ReportType.BY_VACATION) {
      this.vacations.handleRequest(view, context.from, context.to);
      return true;
    }
    if (view.reportType === ReportType.SHIFT) {
      this.shifts.handleRequest(view, context.from, context.to);
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-special-request.coordinator.ts